import { withCustomProductGridHoc } from './HOCs/CustomProductGridHoc';

export default {
    name: 'productsGridPage',
    before: [],
    after: [],
    setup: (app) => {
        const pageName = 'products';
        const pageRoute = app.routes.getItem(pageName);
        if (pageRoute) {
            pageRoute.render = withCustomProductGridHoc();
            app.routes.changeItem(pageName, pageRoute);
        }
    },
};
